import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Award } from 'lucide-react';
const certs = ['Project Management Professional (PMP)', 'PROSCI Certified Change Management Practitioner', 'Certified Scrum Master (CSM)', 'Lean Six Sigma Green Belt', 'Human-Centered Design (HCD)'];
export function Certifications() {
  return <Section id="certifications" background="gray" data-id="element-55" data-mp="29ay6c2ogog8b">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-56" data-mp="2993iafhw8800">
        <div data-id="element-57" data-mp="2dbi3v7cy5luz">
          <FadeIn data-id="element-58" data-mp="2dc9ppqgqs582">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 border-l-4 border-[#1e3a8a] pl-4" data-id="element-59" data-mp="2dap26ksuhmjp">
              Certifications
            </h2>
          </FadeIn>
          <StaggerContainer className="space-y-4" data-id="element-60" data-mp="24atoa87wndfz">
            {certs.map((cert, index) => <StaggerItem key={index} className="flex items-center bg-white p-4 rounded-lg shadow-sm" data-id="element-61" data-mp="nx3j0y51uj4r" data-mpi={index}>
                <Award className="w-6 h-6 text-[#1e3a8a] mr-4 flex-shrink-0" data-id="element-62" data-mp="20qqtamdkr3ku" />
                <span className="text-gray-800 font-medium" data-id="element-63" data-mp="20stgyzr98kme">{cert}</span>
              </StaggerItem>)}
          </StaggerContainer>
        </div>

        <div data-id="element-64" data-mp="2apy5h68kos6d">
          <FadeIn delay={0.2} data-id="element-65" data-mp="2appr19wsxet2">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 border-l-4 border-[#1e3a8a] pl-4" data-id="element-66" data-mp="2amtw7ug9368u">
              Education
            </h2>
          </FadeIn>
          <div className="space-y-6" data-id="element-67" data-mp="2jojmuy2b615k">
            <FadeIn delay={0.3} className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-[#1e3a8a]" data-id="element-68" data-mp="2jnib0rdgxams">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-69" data-mp="2tfo27yvwbo0x">
                Johns Hopkins University
              </h3>
              <p className="text-[#1e3a8a] font-medium" data-id="element-70" data-mp="2oguxauuod5cd">
                MS, Information Systems
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-gray-300" data-id="element-71" data-mp="2yehdrlrmh4yg">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-72" data-mp="35iqpsq7ho1qf">
                Ohio Northern University
              </h3>
              <p className="text-gray-600 font-medium" data-id="element-73" data-mp="3ah1xauaba05h">
                BS, Business Administration
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </Section>;
}